export function ShippingNotice() {
  return (
    <p className="mt-4 text-2xs text-white/60 text-center leading-relaxed">
      Free shipping on all orders.
      <br />
      <span id="points-notice">Earn loyalty points with purchase.</span>
    </p>
  );
}
